import React from 'react';
import { Step } from '@fx-ui/fine-design';
import { isMobileUA, map, range } from '~/utils';
import classNames from 'classnames';

const STEP_COUNT = 3;

export enum REGISTER_STEP {
    REGISTER,
    CORP_PERSONA,
    USER_PERSONA
}

interface RegisterStepProps {
    active?: REGISTER_STEP;
    className?: string;
}

const RegisterStep: React.FC<RegisterStepProps> = ({
    active = REGISTER_STEP.REGISTER,
    className
}) => {
    return (
        <Step
            className={classNames('fx-register-step', className, {
                'is-mobile': isMobileUA()
            })}
            active={active}
            labelPlacement="horizontal"
        >
            {map(range(STEP_COUNT), (step) => (
                <Step.Item key={step} />
            ))}
        </Step>
    );
};

export default RegisterStep;
